import React from 'react';
import { Card, Title, Text } from '@ui5/webcomponents-react';
import Layout from './Layout';

/**
 * Ejemplo de página que utiliza el componente Layout
 */
function ExamplePage() {
  return (
    <Layout>
      <div style={{ padding: '20px' }}>
        <Card style={{ marginBottom: '20px' }}>
          <div style={{ padding: '20px' }}>
            <Title level="H5">Coming Soon...</Title>
            <Text>
              This page is currently under development.
            </Text>
          </div>
        </Card>

      </div>
    </Layout>
  );
}

export default ExamplePage;
